import controller from '../../../../Resources/Scripts/_Shared/Controller';
import CreateAccount from '../../BookingFlowPage/Scripts/steps/CreateAccount';
import React from 'react';
import ReactDOM from 'react-dom';

function editSettingsPage(context) { 
  const appConfig = controller.getConfig(context);

  ReactDOM.render(<CreateAccount editSettings={true} bookingFlowContext={appConfig} formData={appConfig} />, context);
}

controller.add('edit-settings-page', editSettingsPage);